import { asyncAction, syncAction } from 'lib/action';

export const getDocumentInsightsAction = asyncAction('DOCUMENT_INSIGHTS/GET_INSIGHTS');
export const getDocumentInsightsVendorAction = asyncAction('DOCUMENT_INSIGHTS/GET_INSIGHTS_VENDOR');
export const resetDocumentInsightsAction = syncAction('DOCUMENT_INSIGHTS/RESET_DATA');
